<template>
  <div style="width:100%;float:left;">
    <CCard border-color="success">
      <CCardHeader @click="show = !show">
        People Involved
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${show ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="show" :duration="400">
        <CCardBody>
          <div class="personWrapper">
            <label class="type">CSR</label>
            <label class="name">{{data ? data.csr.name : 'No CSR Linked'}}</label>
            <label class="email">{{data ? data.csr.email : 'No CSR Linked'}}</label>
          </div>
          <spacer width="100"></spacer>
          <div class="personWrapper" v-if="rep">
            <label class="type">REP</label>
            <label class="name">{{rep.name}}</label>
            <label class="email">{{rep.email}}</label>
          </div>
          <spacer width="100"></spacer>
          <div class="personWrapper">
            <label class="type">Submitted By</label>
            <label class="name">{{user_submitted ? user_submitted.name : ''}}</label>
            <label class="email">{{user_submitted ? user_submitted.email : ''}}</label>
          </div>
          <spacer width="100"></spacer>
          <div class="personWrapper">
            <label class="type">CSR Assigned</label>
            <label class="name">{{groupData ? groupData.csr_assigned.name : 'Not Assigned Yet'}}</label>
            <label class="email">{{groupData ? groupData.csr_assigned.email : ''}}</label>
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getPeopleInvolved = function () {
  const postData = {
    order_id: this.order_id,
    order_group_id: this.order_group_id
  }
  axios.post(this.$apiAdress + '/api/orders/getPeopleInvolved?token=' + localStorage.getItem('api_token'), postData)
  .then(response => {
    console.log(response)
    this.data = response.data.res
    this.rep = response.data.rep
    this.user_submitted = response.data.user_submitted
    this.groupData = response.data.group
  })
}

export default {
    // ===Component name
    name: "PeopleInvolved",
    // ===Props passed to component
    props: ['order_id', 'order_group_id'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: null,
          show: false,
          rep: '',
          user_submitted: '',
          groupData: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getPeopleInvolved()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .personWrapper {
    width:100%;
    float:left;

    label {
      width: 100%;
      float:left;
    }
  }
</style>
